module.exports = __webpack_public_path__ + "img/chart-error.74149ade.svg";